// import BasicInfo from "../../teachers-detail/components/BasicInfo";

import BasicInfo from "../../../components/basic-info/BasicInfo";

interface IGuardianDetails {
  data: IGuardian;
}

interface IGuardian {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email: string;
}

export default function GuardianDetails() {
  return (
    <div className="section">
      <div className="more-profile-info">
        <h4>Guardian Detail</h4>

        <BasicInfo title="First Name" data="no data" />
        <BasicInfo title="Last Name" data="no data" />
        <BasicInfo title="Date of Birth" data="no data" />
        <BasicInfo title="Email Address" data="no data" />
      </div>
    </div>
  );
}
